import Enum from "./Enum";

const toggleState = Object.create( Enum );
toggleState.UNTOGGLED = "UNTOGGLED";
toggleState.OPEN = "OPEN";
toggleState.CLOSED = "CLOSED";

export default Object.freeze( toggleState );



// WEBPACK FOOTER //
// ./src/constants/NavSidebarToggleState.js